module.exports = __webpack_public_path__ + "static/media/IMAGE-5-CHICKENS-desktop.e3b66bd5.jpg";